document.addEventListener("DOMContentLoaded", function () {
	// Create a reusable dialog element
	let dialog = document.createElement("dialog");
	dialog.classList.add("bds-lightbox-dialog");
	dialog.setAttribute("role", "dialog");
	dialog.setAttribute("aria-modal", "true");
	dialog.setAttribute("tabindex", "-1");
	// Create overlay if not exists
	let overlay = document.querySelector('.bds-lightbox-overlay');
	if (!overlay) {
		overlay = document.createElement('div');
		overlay.className = 'bds-lightbox-overlay';
		document.body.appendChild(overlay);
		overlay.style.display = 'none';
	}
	document.body.appendChild(dialog);

	// Add a close button
	let closeBtn = document.createElement("button");
	closeBtn.textContent = "";
	closeBtn.className = "bds-lightbox-close";
	closeBtn.setAttribute("aria-label", "Close dialog");
	dialog.appendChild(closeBtn);

	let lastActiveElement = null;

	function trapFocus(e) {
		const focusableEls = dialog.querySelectorAll(
			'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
		);
		const firstFocusableEl = focusableEls[0];
		const lastFocusableEl = focusableEls[focusableEls.length - 1];

		if (e.key === "Tab") {
			if (e.shiftKey) {
				// shift + tab
				if (document.activeElement === firstFocusableEl) {
					e.preventDefault();
					lastFocusableEl.focus();
				}
			} else {
				// tab
				if (document.activeElement === lastFocusableEl) {
					e.preventDefault();
					firstFocusableEl.focus();
				}
			}
		}
	}

	closeBtn.addEventListener("click", () => dialog.close());

	dialog.addEventListener("click", function (e) {
		if (e.target === dialog) {
			dialog.close();
		}
	});

	dialog.addEventListener("close", () => {
		// Remove all content except the close button
		[...dialog.children].forEach((child) => {
			if (child !== closeBtn) dialog.removeChild(child);
		});
		// Hide overlay
		let overlay = document.querySelector('.bds-lightbox-overlay');
		if (overlay) {
			overlay.style.display = 'none';
			overlay.classList.remove("bds-lightbox-overlay--video");
		}
		// Remove light controls class
		dialog.classList.remove("bds-lightbox--light-controls");
		// Restore focus to last active element
		if (lastActiveElement) lastActiveElement.focus();
	});

	dialog.addEventListener("keydown", function (e) {
		if (e.key === "Escape") dialog.close();
		trapFocus(e);
	});

	// Lightbox for button links (supports ID or file)
	document
		.querySelectorAll(".wp-block-button.lightbox a")
		.forEach(function (lightbox) {
			const url = lightbox.getAttribute("href");
			const hash = new URL(url, window.location.href).hash;
			const content = hash ? document.querySelector(hash) : null;

			lightbox.addEventListener("click", function (e) {
				e.preventDefault();
				lastActiveElement = lightbox;

				// Remove previous content except close button
				[...dialog.children].forEach((child) => {
					if (child !== closeBtn) dialog.removeChild(child);
				});

				if (content) {
					// If the target has the lightbox-target class, set display block
					if (content.classList.contains('lightbox-target')) {
						content.style.display = "block";
					}
					content.setAttribute("aria-hidden", "false");
					dialog.appendChild(content);

					dialog.showModal();
					closeBtn.focus();

					dialog.addEventListener(
						"close",
						function () {
							// If the target has the lightbox-target class, set display none
							if (content.classList.contains('lightbox-target')) {
								content.style.display = "none";
							}
							content.setAttribute("aria-hidden", "true");
							document.body.appendChild(content); // Restore to original place
						},
						{ once: true },
					);
				} else {
					// Detect file type and render accordingly
					let fileType = "";
					if (/\.(jpe?g|png|gif|webp|svg)$/i.test(url)) {
						fileType = "image";
					} else if (/\.(mp4|webm|ogg)$/i.test(url)) {
						fileType = "video";
					} else if (/\.(pdf)$/i.test(url)) {
						fileType = "pdf";
					} else if (
						/^https?:\/\/(www\.)?(youtube\.com|youtu\.be)/i.test(
							url,
						)
					) {
						fileType = "youtube";
					} else {
						fileType = "iframe";
					}

					// Add light controls class for image or video
					if (["image", "video"].includes(fileType)) {
						dialog.classList.add("bds-lightbox--light-controls");
					} else {
						dialog.classList.remove("bds-lightbox--light-controls");
					}

					// Create wrapper
					const wrapper = document.createElement("div");
					wrapper.className = `bds-lightbox-content bds-lightbox-content--${fileType}`;

					let el;
					switch (fileType) {
						case "image":
							el = document.createElement("img");
							el.src = url;
							el.alt = lightbox.textContent || "Image preview";
							el.style.maxWidth = "90vw";
							el.style.maxHeight = "80vh";
							break;
						case "video":
							el = document.createElement("video");
							el.src = url;
							el.controls = true;
							el.autoplay = true; // Start video automatically
							overlay.classList.add("bds-lightbox-overlay--video");
							break;
						case "pdf":
							overlay.classList.remove("bds-lightbox-overlay--video");
							el = document.createElement("iframe");
							el.src = url;
							el.type = "application/pdf";
							el.style.width = "90vw";
							el.style.height = "80vh";
							el.setAttribute("title", "PDF preview");
							break;
						case "youtube":
							overlay.classList.remove("bds-lightbox-overlay--video");
							el = document.createElement("iframe");
							const ytId = url.match(
								/(?:v=|\/)([0-9A-Za-z_-]{11})/,
							);
							el.src = ytId
								? `https://www.youtube.com/embed/${ytId[1]}`
								: url;
							el.allow =
								"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
							el.allowFullscreen = true;
							el.style.width = "90vw";
							el.style.height = "60vh";
							el.setAttribute("title", "YouTube video");
							break;
						default:
							overlay.classList.remove("bds-lightbox-overlay--video");
							el = document.createElement("iframe");
							el.src = url;
							el.style.width = "90vw";
							el.style.height = "80vh";
							el.setAttribute("title", "File preview");
					}
					wrapper.appendChild(el);
					dialog.appendChild(wrapper);
					overlay.style.display = 'block';
					dialog.showModal();
					closeBtn.focus();
				}
			});
		});

	// Lightbox for gallery images with cycling
	document
		.querySelectorAll(".wp-block-gallery a")
		.forEach(function (galleryLink) {
			galleryLink.addEventListener("click", function (e) {
				e.preventDefault();
				lastActiveElement = galleryLink;

				// Get all gallery links in the same gallery
				const gallery = galleryLink.closest(".wp-block-gallery");
				const links = Array.from(gallery.querySelectorAll("a"));
				let currentIndex = links.indexOf(galleryLink);

				function showImage(index) {
					// Add light controls class for gallery images
					dialog.classList.add("bds-lightbox--light-controls");
					// Remove previous images/descriptions/buttons
					[...dialog.children].forEach((child) => {
						if (child !== closeBtn) dialog.removeChild(child);
					});

					const img = document.createElement("img");
					img.src = links[index].href;
					img.alt =
						links[index].querySelector("img")?.alt ||
						"Gallery image";
					img.style.maxWidth = "90vw";
					img.style.maxHeight = "80vh";
					img.setAttribute("aria-describedby", "dialog-img-desc");
					img.className = "bds-lightbox-fade";
					dialog.appendChild(img);

					// Fade in effect
					requestAnimationFrame(() => {
						img.classList.add("bds-lightbox-fade--in");
					});

					let desc = document.createElement("div");
					desc.id = "dialog-img-desc";
					desc.style.position = "absolute";
					desc.style.left = "-9999px";
					desc.textContent =
						"Image preview in modal dialog. Press Escape to close.";
					dialog.appendChild(desc);

					// Prev button
					if (index > 0) {
						let prevBtn = document.createElement("button");
						prevBtn.setAttribute("aria-label", "Previous");
						prevBtn.className = "bds-lightbox-prev";
						prevBtn.onclick = () => {
							currentIndex = currentIndex - 1;
							showImage(currentIndex);
						};
						dialog.appendChild(prevBtn);
					}

					// Next button
					if (index < links.length - 1) {
						let nextBtn = document.createElement("button");
						nextBtn.setAttribute("aria-label", "Next");
						nextBtn.className = "bds-lightbox-next";
						nextBtn.onclick = () => {
							currentIndex = currentIndex + 1;
							showImage(currentIndex);
						};
						dialog.appendChild(nextBtn);
					}
				}

				showImage(currentIndex);
				overlay.style.display = 'block';
				dialog.showModal();
				closeBtn.focus();

				// Keyboard navigation
				dialog.onkeydown = function (ev) {
					if (ev.key === "ArrowLeft" && currentIndex > 0) {
						currentIndex--;
						showImage(currentIndex);
					} else if (
						ev.key === "ArrowRight" &&
						currentIndex < links.length - 1
					) {
						currentIndex++;
						showImage(currentIndex);
					}
				};
			});
		});
});
